module.exports = __webpack_public_path__ + "img/ertiga-color.f8ab8ac9.svg";